module.exports = __webpack_public_path__ + "img/img10.689b88db.svg";